import { cn } from '@/lib/utils'
import type { HealthAlert } from '@/services/birdbrain-api-client'
import { AlertTriangle, ArrowRight, XCircle } from 'lucide-react'
import { Link } from 'react-router-dom'

/**
 * One actionable system-health alert. Level-colored, links to the BirdBrain
 * route where the operator can act. Shared by Home (alerts strip) and the
 * System Health status hero.
 */
export function HealthAlertRow({ alert }: { alert: HealthAlert }) {
  const isError = alert.level === 'error'
  return (
    <Link
      to={alert.href}
      className={cn(
        'flex items-center gap-3 rounded-lg border px-3 py-2 transition-colors hover:bg-muted/40',
        isError ? 'border-red-500/30 bg-red-500/5' : 'border-amber-500/30 bg-amber-500/5'
      )}
    >
      {isError ? (
        <XCircle className="h-4 w-4 shrink-0 text-red-500" />
      ) : (
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" />
      )}
      <div className="min-w-0 flex-1">
        <p
          className={cn(
            'text-sm font-medium',
            isError ? 'text-red-600 dark:text-red-400' : 'text-amber-600 dark:text-amber-400'
          )}
        >
          {alert.title}
        </p>
        <p className="truncate text-xs text-muted-foreground">{alert.detail}</p>
      </div>
      <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground" />
    </Link>
  )
}
